import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import { Distance } from './types';

export const countryCodeToOption = (
  distance: Distance,
  codes: Option[],
  key: 'fromCountryCode' | 'toCountryCode'
) => {
  const labelKey = distance[key];

  return {
    label: codes.find((item) => item.value === labelKey)?.label ?? '',
    value: codes.find((item) => item.value === labelKey)?.value ?? ''
  };
};
